/**
 * Checks whether the given value is `null`, `undefined`, an empty string,
 * an empty array, or an empty object.
 *
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the value is empty or undefined, otherwise `false`.
 */
export function isEmpty(value: any): boolean {
  // Is value null, undefined or an empty string?
  if (value === null || value === undefined || value === '') return true

  // Is value an empty array?
  if (Array.isArray(value)) return value.length === 0

  // Is value an empty object without keys?
  if (typeof value === 'object') {
    if (
      Array.isArray(value) ||
      (!Object.keys(value).length &&
        !(value instanceof Date) &&
        !(value instanceof File))
    )
      return true
  }

  return false
}
